export const staffingRequestTypes = ['long_term', 'on_demand'];

export const staffingRequestTypeHumanized = (value: string) => {
  switch (value) {
    case 'long_term':
      return 'Long Term';
    case 'on_demand':
      return 'On-Demand';
    default:
      return value;
  }
};
